import gql from 'graphql-tag';

export default gql`
  mutation StartAddBillingMethod($accountId: ID!) {
    startAddBillingMethod(accountId: $accountId) {
      customerSecret
    }
  }
`;
